export default "__VITE_ASSET__628b6fb4__"